import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Media from "react-media";

import { connect } from 'react-redux';
import { fetchBlogs } from './actions';
import { bindActionCreators } from 'redux';



class Nav extends Component {
    constructor (props) {
        super(props)
        this.state = {
            clickBurger: false,
            clickListMenuMobile: false,
            clickSubMenuMobile: false
        }
        this.handleClickBurger = this.handleClickBurger.bind(this);
        this.handleClickDropdownMobile = this.handleClickDropdownMobile.bind(this);
        this.handleClickSubMenuMobile = this.handleClickSubMenuMobile.bind(this);
    }

    componentWillMount() {
        this.props.fetchBlogs()
    }

    handleClickSubMenuMobile() {
        this.setState({ clickSubMenuMobile: true, clickListMenuMobile: false })
    }
    handleClickDropdownMobile() {
        this.setState({ clickListMenuMobile: !this.state.clickListMenuMobile })
    }
    handleClickBurger() {
        this.setState({ clickBurger: !this.state.clickBurger })
    }
    renderSubmenuMobile() {
        let categoryNotDupArr = [];
        for (var i = 0; i < this.fetchSubmenu().length; i++) {
            if (this.fetchSubmenu().indexOf(this.fetchSubmenu()[i]) !== i &&
                this.fetchSubmenu().indexOf(this.fetchSubmenu()[i]) !== -1) {

            } else {
                categoryNotDupArr.push(this.fetchSubmenu()[i])
            }
        }


        let result  = []
        categoryNotDupArr.map((category, i) => {
            let categorySlug = `/category/${category}`;
            if(category !== undefined) {
                return result.push(<li key={i} onClick={this.handleClickSubMenuMobile}>
                        <Link to={categorySlug} className="dropdown-item submenu-list">{category}</Link>
                    </li>)
            }else {
                return <div />
            }

        })

        return result
    }
    fetchSubmenu() {
        let categories = [];
        if(this.props.state.fetchBlogs.items !== undefined){
            this.props.state.fetchBlogs.items.map((blog) => {
                if(blog.sys.contentType.sys.id === "article") {
                    if(blog.fields.category !== undefined){
                        const categoryLowerCase = blog.fields.category.toLowerCase()
                        categories.push(categoryLowerCase)
                    }

                }else {
                    return <div />
                }
            })
        }

        return categories;
    }


    renderSubmenuDesktop() {
        let categoryNotDupArr = [];
        for (var i = 0; i < this.fetchSubmenu().length; i++) {
            if (this.fetchSubmenu().indexOf(this.fetchSubmenu()[i]) !== i &&
                this.fetchSubmenu().indexOf(this.fetchSubmenu()[i]) !== -1) {

            } else {
                categoryNotDupArr.push(this.fetchSubmenu()[i])
            }
        }

        let result  = []
        categoryNotDupArr.map((category, i) => {
            let categorySlug = `/category/${category}`;
            if(category !== undefined) {
                return result.push(<li key={i}><Link to={categorySlug} className="dropdown-item submenu-list">{category}</Link>
                    </li>)
            }
        })

        return result

    }
    render() {
        const closeMenuClass = this.state.clickBurger ? 'ion-ios-close-empty close-menu-icon menu-list-show' : 'ion-ios-close-empty close-menu-icon menu-list-hide';
        const burgerMenuClass = this.state.clickBurger ? 'ion-navicon menu-icon-mobile menu-list-hide' : 'ion-navicon menu-icon-mobile menu-list-show';
        const toggleMenuClass = this.state.clickBurger ? 'navbar-collapse menu-list-show' : 'navbar-collapse menu-list-hide';
        const iconDropdownMobileClass = this.state.clickListMenuMobile ? 'nav-link hide-dropdown' : 'nav-link with-dropdown';
        const dropdownMobileClass = this.state.clickListMenuMobile ? 'dropdown-menu-mobile menu-list-show' : 'dropdown-menu-mobile menu-list-hide';
        return (
            <div className="container-fluid no-left-padding no-right-padding menu-block">
                <div className="container contain-nav-custom">
                    <nav className="navbar ownavigation navbar-expand-lg nav-custom">
                        <Link className="navbar-brand" to="/">esportswire</Link>
                        <div className="menu-mobile-wrap" onClick={this.handleClickBurger}>
                            <i className={burgerMenuClass}></i>
                            <i className={closeMenuClass}></i>
                        </div>
                            <div className={toggleMenuClass}>
                                <ul className="navbar-nav nopaddingleft">
                                    <li className="dropdown" onClick={this.handleClickBurger}>
                                        <Link className="nav-link" to="/">Home</Link>
                                    </li>
                                    <Media query="(max-width: 991px)">
                                        {matches =>
                                            matches ? (
                                                <li className="dropdown">
                                                    <div className={iconDropdownMobileClass} onClick={this.handleClickDropdownMobile}>POSTS</div>
                                                    <ul className={dropdownMobileClass}>
                                                        {this.renderSubmenuMobile()}
                                                    </ul>
                                                </li>
                                            ) : (
                                                <li className="dropdown">
                                                    <div className="nav-link">POSTS</div>
                                                    <ul className="dropdown-menu">
                                                        {this.renderSubmenuDesktop()}
                                                    </ul>
                                                </li>
                                            )
                                        }
                                    </Media>
                                </ul>
                            </div>
                    </nav>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        state
    };
}
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        fetchBlogs:fetchBlogs
    }, dispatch)
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Nav)


// WEBPACK FOOTER //
// ./src/nav.js